module.exports = __webpack_public_path__ + "static/img/核心2.513d70d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/核心2.png
// module id = i1MS
// module chunks = 1